// extracted by mini-css-extract-plugin
var _1 = "leftSide__xKmzx";
var _2 = "rightSide__UWd3P";
var _3 = "row__tnz_t";
var _4 = "wrapper__LYio8";
export { _1 as "leftSide", _2 as "rightSide", _3 as "row", _4 as "wrapper" }
export default { "leftSide": _1, "rightSide": _2, "row": _3, "wrapper": _4 }
